import { getLogger } from 'shared/logger'
import type { GalleryContentQuery } from 'shared/types/gallery/content-query'
import type { DTT } from 'shared/types/vp/dtt'

function parseFavoriteProductOptions(merchandising: DTT.Models.WorkEntityService.Merchandising): DTT.Models.WorkEntityService.MerchandisingSelections {
  const options = { fullProductOptions: null, productOptions: null }

  try {
    const { merchandisingSelections } = merchandising
    const { fullProductOptions, productOptions } = merchandisingSelections

    options.fullProductOptions = fullProductOptions ? JSON.parse(fullProductOptions as string) : { ...merchandisingSelections }

    options.productOptions = productOptions ? JSON.parse(productOptions as string) : { ...merchandisingSelections }
  } catch (e) {
    getLogger().error(e as Error)
  }

  return options
}

function parsePreviewInfo(metadata: DTT.Models.WorkEntityService.DesignMetadata<string>): GalleryContentQuery.PreviewInfo | null {
  if (!metadata.previewInfo || metadata.previewInfo === 'null') {
    return null
  }

  try {
    return JSON.parse(metadata.previewInfo as string)
  } catch (e) {
    getLogger().error(e as Error)
  }

  return null
}

export function parseWorkEntity(
  favorite: DTT.Models.WorkEntityService.WorkEntity<string>,
): DTT.Models.WorkEntityService.WorkEntity<GalleryContentQuery.PreviewInfo> {
  const { merchandising, design } = favorite
  const options = parseFavoriteProductOptions(merchandising)
  const parsedPreviewInfo = parsePreviewInfo(design.metadata)

  return {
    ...favorite,
    design: {
      ...design,
      metadata: {
        ...design.metadata,
        previewInfo: parsedPreviewInfo,
      },
    },
    merchandising: {
      ...merchandising,
      merchandisingSelections: options,
    },
  }
}

export function stringifyWorkEntityProperties(
  favorite: DTT.Models.WorkEntityService.WorkEntity<GalleryContentQuery.PreviewInfo>,
): DTT.Models.WorkEntityService.WorkEntity<string> {
  const { merchandising, design } = favorite

  return {
    ...favorite,
    design: {
      ...design,
      metadata: {
        ...design.metadata,
        previewInfo: JSON.stringify(design.metadata.previewInfo),
      },
    },
    merchandising: {
      ...merchandising,
      merchandisingSelections: {
        ...merchandising.merchandisingSelections,
        fullProductOptions: JSON.stringify(merchandising.merchandisingSelections.fullProductOptions),
        productOptions: JSON.stringify(merchandising.merchandisingSelections.productOptions),
      },
    },
  }
}
